import { render, staticRenderFns } from "./host-news-audit.vue?vue&type=template&id=4510cb86&scoped=true&"
import script from "./host-news-audit.vue?vue&type=script&lang=js&"
export * from "./host-news-audit.vue?vue&type=script&lang=js&"
import style0 from "./host-news-audit.vue?vue&type=style&index=0&id=4510cb86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4510cb86",
  null
  
)

export default component.exports